import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  .feature {
    display: flex;
    align-items: center;

    .icon-container {
      width: 23px;
      height: 23px;
      margin-right: 15px;
    }

    p {
      margin: 0;
      font-size: 17px;
      text-align: left;
      font-weight: 300;
      line-height: 22px;
      text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.16);
    }
  }

  .feature:not(:last-child) {
    margin-bottom: 20px;
  }
`;
